import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';

import {
  ServiceMenuAddPayload,
  ServiceMenuItem,
  ServiceMenuListItem,
  ServiceMenuListRequestPayload,
} from './models/index';

const serviceMenuListService = {
  getServiceMenuList(params?: ServiceMenuListRequestPayload): Promise<CommonResponse<ServiceMenuListItem[]>> {
    const url = `/service-menu`;
    return axiosClient.get(url, { params });
  },
  add(payload: Partial<ServiceMenuAddPayload[]>): Promise<CommonResponse<any>> {
    const url = '/service-menu';
    return axiosClient.post(url, payload);
  },
  updates(payload: Partial<ServiceMenuItem[]>): Promise<CommonResponse<any>> {
    const url = `/service-menu`;
    return axiosClient.patch(url, payload);
  },
};

export default serviceMenuListService;
